import React from "react";
import { useDispatch } from "react-redux";
import { formSet } from "../../actions/appActions";
import { initialCpdYear } from "../../constants/factories";
import { AddCircle } from "@mui/icons-material";
import { Button } from "@mui/material";
import { TYPE_CPD_YEAR } from "../../api/api";
import CpdYearList from "./CpdYearList";

const CpdYear = () => {
  const dispatch = useDispatch();

  const handleCreate = () => {
    dispatch(formSet(TYPE_CPD_YEAR, { ...initialCpdYear }));
  };

  return (
    <>
      <Button
        sx={{ mt: 2, mb: 2 }}
        onClick={handleCreate}
        color="primary"
        variant="contained"
        disableElevation
        startIcon={<AddCircle />}
      >
        Vytvořit roční minimální požadavky
      </Button>
      <CpdYearList />
    </>
  );
};

export default CpdYear;
